import { useQuery } from '@sequencehq/api/utils'
import {
  dashboardv99990101Client,
  Dashboardv99990101CommonModels
} from '@sequencehq/api/dashboard/v99990101'

export type TaxIntegrationProvider =
  Dashboardv99990101CommonModels.TaxIntegration.TaxIntegrationProvider
export const TAX_INTEGRATION_PROVIDERS: Record<
  TaxIntegrationProvider,
  TaxIntegrationProvider
> = {
  ANROK: 'ANROK',
  AVALARA: 'AVALARA',
  SEQUENCE: 'SEQUENCE',
  NUMERAL: 'NUMERAL',
  SPHERE: 'SPHERE'
}

const getTaxIntegrationProviderFlags = (
  taxIntegrationProvider: TaxIntegrationProvider | undefined
) => ({
  isAnrok: taxIntegrationProvider === TAX_INTEGRATION_PROVIDERS.ANROK,
  isAvalara: taxIntegrationProvider === TAX_INTEGRATION_PROVIDERS.AVALARA,
  isSequence: taxIntegrationProvider === TAX_INTEGRATION_PROVIDERS.SEQUENCE,
  isNumeral: taxIntegrationProvider === TAX_INTEGRATION_PROVIDERS.NUMERAL,
  isSphere: taxIntegrationProvider === TAX_INTEGRATION_PROVIDERS.SPHERE,
  isExternalTaxIntegrationProvider:
    taxIntegrationProvider !== TAX_INTEGRATION_PROVIDERS.SEQUENCE,
  taxIntegrationProvider
})

// We sometimes check the provider outside of React components so this is the same that hook does just in an async fn
export const getTaxIntegrationProvider = async () => {
  const result = await dashboardv99990101Client.getEnabledTaxIntegration()

  const taxIntegrationProvider = result?.data?.taxIntegrationProvider

  return getTaxIntegrationProviderFlags(taxIntegrationProvider)
}

export const useTaxIntegrationProvider = () => {
  const { data: taxIntegrationData, isLoading } = useQuery(
    dashboardv99990101Client.getEnabledTaxIntegration
  )

  const taxIntegrationProvider = taxIntegrationData?.taxIntegrationProvider

  // While the query is loading, the provider is undefined so every flag reads
  // false. Callers gating on tax state must wait on `isLoading`, not treat
  // "not Avalara / not external" as resolved.
  return {
    ...getTaxIntegrationProviderFlags(taxIntegrationProvider),
    isLoading
  }
}
